import React from 'react'
import PropTypes from 'prop-types'

const NextSliderIcon = ({
  width = 50,
  height = width,
  fill = 'black',
  opacity = 0.3,
  color = 'white',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 50 50"
      fill="none">
      <circle
        cx="25"
        cy="25"
        r="25"
        transform="rotate(-180 25 25)"
        fill={fill}
        fillOpacity={opacity}
      />
      <path d="M43.5715 25L15.7144 41.0833L15.7144 8.91669L43.5715 25Z" fill={color} />
    </svg>
  )
}

NextSliderIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  opacity: PropTypes.any,
  color: PropTypes.string,
}

export default React.memo(NextSliderIcon)
